import Tooltip from '@mui/material/Tooltip';

export function WTooltip(props) {
  const {
    arrow = true,
    placement = 'bottom',
    enterDelay = 300,
    leaveDelay = 100,
    slotProps = {
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: { offset: [0, -10] },
          },
        ],
      },
    },
    disableInteractive = true,
    ...rest
  } = props;

  return (
    <Tooltip
      arrow={arrow}
      slotProps={slotProps}
      placement={placement}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
      disableInteractive={disableInteractive}
      {...rest}
    />
  );
}